<div class="sidebar-settings">
  <div class="sidebar-settings__item">
    <span class="sidebar-settings__item__circle">
      {{ user.initials | removeWhiteSpace }}
    </span>
    <span class="sidebar-settings__item__text">
      {{ 'sidebar-settings.profile' | translate }}
    </span>
    <div class="submenu">
      <div class="submenu-header">{{ user.firstName }} {{ user.lastName }}</div>
      <a class="submenu__link" href="#" [routerLink]="['/user', user.id, 'profile']">
        <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/icon-user.svg" />
        <div class="submenu__link__text">{{ 'sidebar-settings.my_profile' | translate }}</div>
      </a>

      @if (user.adminPanel) {
        <a class="submenu__link" href="#" [routerLink]="['/admin-main-accounts']">
          <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/icon-user.svg" />
          <div class="submenu__link__text">{{ 'sidebar-settings.admin_main_accounts' | translate }}</div>
        </a>
      }

      <a class="submenu__link" href="#" [routerLink]="['/main-account', user.mainAccountId || '', 'main-information']">
        <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/icon-user.svg" />
        <div class="submenu__link__text">{{ 'sidebar-settings.company_profile' | translate }}</div>
      </a>
      @if (electron) {
        <a class="submenu__link" href="#" [routerLink]="['/pi-drive-settings']">
          <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/sync_new.svg" />
          <div class="submenu__link__text">{{ 'electron.sidebar.pi-drive' | translate }}</div>
        </a>
      }
      <a class="submenu__link" href="#" (click)="logOut($event)">
        <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/logout.svg" />
        <div class="submenu__link__text">{{ 'sidebar-settings.log_out' | translate }}</div>
      </a>
    </div>
  </div>
  @for (settingsItem of settingsMenuItems; track settingsItem) {
    <a
      class="sidebar-settings__item"
      href="#"
      [routerLink]="settingsItem.url"
      [class.current]="isCurrent(settingsItem)"
      >
      <span class="sidebar-settings__item__svg">
        <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/{{ settingsItem.icon }}.svg" />
        @if (settingsItem.notification) {
          <span class="sidebar-settings__item__svg--number">{{ user.newMessagesCount }}</span>
        }
      </span>
      <span class="sidebar-settings__item__text">
        {{ settingsItem.title }}
      </span>
      @if (settingsItem.submenu) {
        <div class="submenu">
          @for (submenuItem of settingsItem.submenu; track submenuItem) {
            <a class="submenu__link" href="#" [routerLink]="submenuItem.url">
              <svg-icon [applyClass]="true"
                class="svgImage"
                src="/assets/img/icons/{{ submenuItem.icon }}.svg"
               />
              <div class="submenu__link__text">{{ submenuItem.title }}</div>
            </a>
          }
        </div>
      }
    </a>
  }
  @if (!electron) {
    <a class="sidebar-settings__item temp-switch" href="https://app.platformainzynierow.pl/PI1/">
      <span class="sidebar-settings__item__svg">
        <svg-icon [applyClass]="true" class="svgImage" src="/assets/img/icons/arrow-switch.svg" />
      </span>

      <span class="sidebar-settings__item__text">
        {{ 'sidebar-settings.switch-version' | translate }}
      </span>
    </a>
  }
</div>
